import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { ConfirmVanityUrlForm, ConfirmVanityUrlFormTitle } from './components/ConfirmVanityUrlForm';
import { CreateVanityUrlForm, CreateVanityUrlFormTitle } from './components/CreateVanityUrlForm';
import { useVanityModalState, VanityModalStateContextProvider } from './modalContext/context';

// This modal contains two states
export const useVanityLinkModal = createModalHook<
	{ petitionSlug: string; petitionId: string; displayedSignatures: number },
	{ status: 'success'; url: string }
>({
	name: 'VanityLinkModal',
	heading: function VanityLinkTitle() {
		const [{ viewState }] = useVanityModalState();

		return <>{viewState === 'CREATE' ? <CreateVanityUrlFormTitle /> : <ConfirmVanityUrlFormTitle />}</>;
	},
	body: function VanityLinkBody({ options: { petitionSlug, petitionId, displayedSignatures }, closeModal }) {
		const [{ viewState }] = useVanityModalState();

		return (
			<>
				{viewState === 'CREATE' ? (
					<CreateVanityUrlForm petitionId={petitionId} displayedSignatures={displayedSignatures} />
				) : (
					<ConfirmVanityUrlForm
						closeModal={closeModal}
						petitionSlug={petitionSlug}
						petitionId={petitionId}
						displayedSignatures={displayedSignatures}
					/>
				)}
			</>
		);
	},
	decorator: ({ children }) => <VanityModalStateContextProvider>{children}</VanityModalStateContextProvider>,
	stylesOverrides: {
		paddingX: [8, null, 16],
		paddingY: [16, null, 16],
		width: ['calc(100vw - 10px)', null, 620],
	},
});
